import { render, staticRenderFns } from "./FormCreateMenuPaket.vue?vue&type=template&id=74cc33df"
import script from "./FormCreateMenuPaket.vue?vue&type=script&lang=js"
export * from "./FormCreateMenuPaket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports